// =====================================================
// COMPONENT: TimelineFutureTasks
// Description: Section tâches futures avec actions
// =====================================================

import { PhoneOutgoing, Mail, Calendar, Check, Users } from 'lucide-react';
import { Button } from '../ui/button';
import type { Task } from '@/types/task';
import { formatTaskDueDate } from '@/lib/date-utils';

interface TimelineFutureTasksProps {
  tasks: Task[];
  onComplete: (taskId: string) => Promise<boolean>;
  onReschedule: (taskId: string, daysToAdd: number) => Promise<boolean>;
}

function getTaskIcon(type: Task['type']) {
  const iconClass = 'size-4 text-blue-700';

  switch (type) {
    case 'call':
      return <PhoneOutgoing className={iconClass} />;
    case 'email':
      return <Mail className={iconClass} />;
    case 'meeting':
      return <Users className={iconClass} />;
    case 'other':
    default:
      return <Calendar className={iconClass} />;
  }
}

export function TimelineFutureTasks({ tasks, onComplete, onReschedule }: TimelineFutureTasksProps) {
  if (tasks.length === 0) {
    return null;
  }

  return (
    <div>
      {tasks.map((task) => (
        <div
          key={task.id}
          className="flex gap-3 items-start py-3 border-b border-zinc-100 last:border-0"
        >
          <div className="bg-blue-100 rounded-lg size-8 flex items-center justify-center shrink-0">
            {getTaskIcon(task.type)}
          </div>
          <div className="flex-1">
            <p className="text-base text-zinc-900">{task.title}</p>
            <p className="text-sm text-zinc-500">
              {formatTaskDueDate(task.due_date)}
              {task.created_by_user &&
                ` • par ${task.created_by_user.full_name || task.created_by_user.email}`}
            </p>
            {task.notes && <p className="text-sm text-zinc-600 mt-1">{task.notes}</p>}
          </div>
          <div className="flex gap-1">
            <Button variant="ghost" size="sm" onClick={() => onComplete(task.id)}>
              <Check className="size-4 mr-2" />
              Terminer
            </Button>
            <Button variant="ghost" size="sm" onClick={() => onReschedule(task.id, 7)}>
              <Calendar className="size-4 mr-2" />
              +7j
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
